import apiService from "./api";

const groceryService = {
  getGroceries() {
    return apiService.get("/groceries");
  },
  // Get groceries for warehouse
  getWarehouseGroceries() {
    return apiService.get("/groceries", { warehouse: true });
  },
  // Get parent restaurant groceries
  getParentGroceries(parentRestaurantId) {
    return apiService.post("/groceries/get-parent-groceries", {
      restaurant: parentRestaurantId,
    });
  },
  // Clone groceries from parent restaurant
  cloneParentGroceries(cloneData) {
    return apiService.post("/groceries/add-parent-groceries", {
      clone: cloneData,
    });
  },
  // Delete grocery
  deleteGrocery(groceryId) {
    return apiService.delete(`/groceries/${groceryId}`);
  },
  // Create grocery
  createGrocery(groceryData) {
    return apiService.post('/groceries', groceryData);
  },
  // Update grocery
  updateGrocery(groceryId, groceryData) {
    return apiService.put(`/groceries/${groceryId}`, groceryData);
  },
};

export default groceryService;